import { useEffect, useMemo, useState } from 'react';
import { useNotify } from 'react-admin';
import { format, parseISO } from 'date-fns';
import { SEX_OFFENDER } from '@/pages/Candidate/view/modals/DecisionTreeModal/constants';
import { CopyToClipboardStyled, DynamicText } from '@/pages/Candidate/view/modals/DecisionTreeModal/styled';
import { DecisionTreeModalProps, HeadingRow } from '@/pages/Candidate/view/modals/DecisionTreeModal/types';
import { useModalEffects, saveScrollPosition } from '@/pages/Candidate/view/modals/DecisionTreeModal/utils';

const useController = ({ data, isOpen }: DecisionTreeModalProps) => {
  const notify = useNotify();
  const [savedPosition, setSavedPosition] = useState({ x: 0, y: 0 });

  const id = data?.id;
  const crimeType = data?.crime_type;
  const recordTypeRaw = data?.record_type;
  const reportToken = data?.report_token;
  const calculationDateRaw = data?.surface_json?.surface_match?.calculation_date;

  const recordType = useMemo(() => {
    const isSexOffender = crimeType?.includes(SEX_OFFENDER);
    return isSexOffender ? SEX_OFFENDER : recordTypeRaw;
  }, [crimeType, recordTypeRaw]);

  const calculationDate = calculationDateRaw ? format(parseISO(calculationDateRaw), 'MM-dd-yyyy') : null;

  const headingRows: HeadingRow[] = useMemo(
    () => [
      {
        label: 'Record ID',
        value: id,
        renderValue: id ? (
          <CopyToClipboardStyled onCopy={() => notify('Record ID copied to clipboard')} text={String(id)}>
            <DynamicText>{id}</DynamicText>
          </CopyToClipboardStyled>
        ) : null,
      },
      { label: 'Record type', value: recordType },
      { label: 'Calculation date', value: calculationDate },
    ],
    [id, recordType, calculationDate, notify]
  );

  useEffect(() => {
    if (isOpen) setSavedPosition(saveScrollPosition());
  }, [isOpen]);

  useModalEffects(isOpen, savedPosition);

  return {
    headingRows,
    notify,
    reportToken,
  };
};

export default useController;
